"use client";

import { useEffect, useState } from "react";
import { useParams } from "next/navigation";
import ErrorPageShell from "@/components/ErrorPageShell";
import { getSynchronousRuntimeErrorContent } from "@/lib/content/entries/runtime-error-fallback";
import { loadLocalizedRuntimeErrorContent } from "@/lib/content/load-runtime-error-content";

type LocaleErrorProps = {
  error: Error & { digest?: string };
  unstable_retry: () => void;
};

export default function LocaleError({ error, unstable_retry }: LocaleErrorProps) {
  const params = useParams<{ locale?: string }>();
  const locale = params?.locale ?? "en";

  return <LocalizedErrorContent key={locale} error={error} locale={locale} unstable_retry={unstable_retry} />;
}

function LocalizedErrorContent({ error, locale, unstable_retry }: LocaleErrorProps & { readonly locale: string }) {
  const [localized, setLocalized] = useState(() => getSynchronousRuntimeErrorContent(locale));

  useEffect(() => {
    console.error(error);
  }, [error]);

  useEffect(() => {
    let cancelled = false;

    void loadLocalizedRuntimeErrorContent(locale).then((localized) => {
      if (!cancelled) setLocalized(localized);
    });

    return () => {
      cancelled = true;
    };
  }, [locale]);

  return (
    <ErrorPageShell
      content={localized.content}
      digest={error.digest}
      includeDocumentMetadata
      onRetry={unstable_retry}
      skipLabel={localized.skipLabel}
    />
  );
}
